export default __webpack_public_path__ + "static/RCS-9cbdc4f3206ff78b1cdee75bd12e0c11.mp4";